<script>
  import AssetCard from '#components/AssetCard';

  let { assets } = $props();
</script>

<div class="asset-grid">
  {#if assets !== null && assets !== undefined && assets.length > 0}
    {#each assets as asset (asset._dom_key || asset.asset_id)}
      <AssetCard {asset} />
    {/each}
  {:else}
    <p>No assets found matching the criteria.</p>
  {/if}
</div>

<style>
  .asset-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
    gap: 1.5rem;
    align-items: start;
  }
</style>